import type { Team } from 'features/team'

const adaptPersona = ({
	added,
	email,
	linkedin_profile,
	nickname,
	pending,
	persona_id,
	role,
	subscription
}: Team.Persona) => ({
	added,
	avatar: linkedin_profile?.picture_url,
	email,
	entityId: linkedin_profile?.linkedin_entity_id,
	id: persona_id,
	linkedin_profile,
	nickname,
	pending,
	publicIdentifier: linkedin_profile?.linkedin_public_identifier,
	role,
	subscription
})

export { adaptPersona }
